import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTASection() {
  const { ref: contentRef, isVisible } = useScrollReveal(0.2);

  return (
    <section id="contact" className="relative bg-primary-900 py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-primary-700/40 blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-500/10 blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div
        ref={contentRef}
        className={`relative max-w-4xl mx-auto text-center transition-all duration-800 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 text-background-50/80 text-xs font-bold tracking-widest uppercase mb-6">
          Let&apos;s Talk
        </span>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-7xl font-bold text-background-50 leading-[1.08] mb-5">
          Ready to Build Your{' '}
          <span className="text-accent-300 italic">Dream Team?</span>
        </h2>
        <p className="text-background-50/65 text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-12">
          Whether you need a single executive hire or a complete recruitment strategy, we&apos;re ready to partner with you. Let&apos;s discuss how we can help.
        </p>

        {/* Contact cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mb-10">
          <a
            href="tel:+918447691414"
            className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-50/8 hover:bg-background-50/12 border border-background-50/10 transition-all duration-300 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-2xl bg-accent-500/20 flex items-center justify-center group-hover:bg-accent-500/30 transition-colors">
              <i className="ri-phone-fill text-accent-300 text-xl"></i>
            </div>
            <div>
              <p className="text-background-50/50 text-xs font-medium tracking-widest uppercase mb-1">Call Us</p>
              <p className="text-background-50 font-bold text-sm">+91 8447691414</p>
            </div>
          </a>

          <a
            href="tel:+919799374635"
            className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-50/8 hover:bg-background-50/12 border border-background-50/10 transition-all duration-300 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-2xl bg-primary-500/20 flex items-center justify-center group-hover:bg-primary-500/30 transition-colors">
              <i className="ri-phone-fill text-primary-300 text-xl"></i>
            </div>
            <div>
              <p className="text-background-50/50 text-xs font-medium tracking-widest uppercase mb-1">Call Us</p>
              <p className="text-background-50 font-bold text-sm">+91 9799374635</p>
            </div>
          </a>

          <a
            href="mailto:info@jobmanifest.in"
            className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-50/8 hover:bg-background-50/12 border border-background-50/10 transition-all duration-300 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-2xl bg-accent-500/20 flex items-center justify-center group-hover:bg-accent-500/30 transition-colors">
              <i className="ri-mail-line text-accent-300 text-xl"></i>
            </div>
            <div>
              <p className="text-background-50/50 text-xs font-medium tracking-widest uppercase mb-1">Email Us</p>
              <p className="text-background-50 font-bold text-sm">info@jobmanifest.in</p>
            </div>
          </a>
        </div>

        {/* Address */}
        <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50/8 border border-background-50/10">
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-map-pin-line text-accent-300 text-sm"></i>
          </span>
          <span className="text-background-50/70 text-sm font-medium">
            B-37, Sector 63, Noida - 201301
          </span>
        </div>
      </div>
    </section>
  );
}